import { Grid, styled } from '@mui/material';
import { CrmJobDTO, CrmJobFilterDTO } from 'wisestep-api';
import { WsColors, formattedDateISOWithZeroTime } from 'wisestep-base';
import { object, string } from 'yup';

import { linkedInRegex } from '../../clientListingPage/helper/ClientListingHelper';

export interface CrmJobListingResponse {
  content: CrmJobDTO[];
  totalElements: number;
  totalPages: number;
  last: boolean;
  numberOfElements: number;
  first: boolean;
  size: number;
  number: number;
  empty: boolean;
}
export interface ContactFormValues {
  contactList: string[];
}

export const defaultCrmJobFilter: CrmJobFilterDTO = {
  workspaceId: undefined,
  query: '',
  title: '',
  jobStatuses: [],
  jobFunction: '',
  employmentType: '',
  linkedInJobUrl: '',
  location: [],
  clients: [],
  contacts: [],
  jobSource: '',
  isRemote: undefined,
  locations: [],
  includeClosedJobs: false,
  createdByIds: [],
  fromDate: '',
  toDate: '',
  page: 0,
  size: 10,
  sortOrder: '',
  sortBy: '',
  filterByDateType: '',
};

export const mapToCrmJobAdvanceFilter = (data): CrmJobFilterDTO => {
  return {
    page: 0,
    size: 25,
    sortOrder: 'asc',
    sortBy: 'createdOn',
    query: data.query ?? '',
    workspaceId: data.workspaceId,
    title: data.title ?? '',
    jobStatuses: data.jobStatuses ?? [],
    jobFunction: data.jobFunction ?? '',
    employmentType: data.employmentType ?? '',
    linkedInJobUrl: data.linkedInJobUrl ?? '',
    clients: data.clients ?? [],
    contacts: data.contacts ?? [],
    jobSource: data.jobSource ?? '',
    isRemote: data.isRemote ?? false,
    locations: data.locations ?? [],
    includeClosedJobs: data.includeClosedJobs ?? false,
    createdByIds: data.createdByIds ?? [],
    filterByDateType: data.filterByDateType === 'UPDATED_BETWEEN' ? 'modified_on' : 'created_on',
    fromDate: data.fromDate ? formattedDateISOWithZeroTime(data.fromDate) : undefined,
    toDate: data.toDate ? formattedDateISOWithZeroTime(data.toDate) : undefined,
  };
};

export const crmJobsTypes = ['All Jobs', 'My Jobs'];

export const getValidationSchema = () => {
  return object().shape({
    title: string().required('Please provide Job Title').min(1, 'Please provide Job Title'),
    linkedInJobUrl: string()
      .nullable(false)
      .required('Please provide Job URL')
      .matches(linkedInRegex, {
        excludeEmptyString: true,
        message: 'Please provide a valid LinkedIn URL',
      }),
    location: object()
      .required('Please provide Hiring Location')
      .typeError('Please provide Hiring Location'),
    client: object().required('Client is required').nullable(false),
    jobDescription: string()
      .required('Please provide Job Description')
      .min(1, 'Please provide Job Description'),
  });
};

export const CrmStyledFooter = styled(Grid)(() => ({
  position: 'fixed',
  bottom: 0,
  right: 0,
  justifyContent: 'flex-end',
  width: '49.8vw',
  backgroundColor: WsColors.White,
  borderTop: '1px solid' + WsColors.BorderGrey,
}));

export const periodOptions = [
  {
    label: 'Days',
    value: 'DAYS',
  },
  {
    label: 'Weeks',
    value: 'WEEKS',
  },
  {
    label: 'Months',
    value: 'MONTHS',
  },
  {
    label: 'Years',
    value: 'YEARS',
  },
];
